import { useCallback } from 'react';
import { useNoticeBannersStackContext } from '@sweetgreen/garnish';

import { useCancelSubscriptionAtCycleEndMutation } from '@order/graphql';
import { useLocalizationContext } from '@order/Localization';

export const useCancelSweetpassSubscription = (
  props: UseCancelSweetpassSubscriptionProps,
) => {
  const { subscriptionId, onClose } = props;

  const { t } = useLocalizationContext();
  const { push: addNoticeBanner } = useNoticeBannersStackContext();

  const [cancelSweetpassSubscriptionResponse, cancelSweetpassSubscription] =
    useCancelSubscriptionAtCycleEndMutation();
  const isCancellingSubscription = cancelSweetpassSubscriptionResponse.fetching;
  const hasCancelledSubscription =
    cancelSweetpassSubscriptionResponse.data?.cancelSubscriptionAtCycleEnd
      ?.__typename === 'CancelSubscriptionAtCycleEndSuccessResponse';

  const requestCancelSubscription = useCallback(async () => {
    const { data } = await cancelSweetpassSubscription({ subscriptionId });
    const result = data?.cancelSubscriptionAtCycleEnd?.__typename;

    if (result !== 'CancelSubscriptionAtCycleEndSuccessResponse') {
      addNoticeBanner({
        text: t('account.cancel-subscription.error'),
        palette: 'caution',
      });
      onClose();

      return;
    }

    addNoticeBanner({
      text: t('account.cancel-sweetpass-plus-subscription.success'),
      palette: 'success',
    });
  }, [
    subscriptionId,
    t,
    cancelSweetpassSubscription,
    addNoticeBanner,
    onClose,
  ]);

  return {
    isCancellingSubscription,
    hasCancelledSubscription,
    requestCancelSubscription,
  };
};

type UseCancelSweetpassSubscriptionProps = {
  readonly subscriptionId: string;
  readonly onClose: () => void;
};
